import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
// import ProductSection from "./ProductSection";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data, variant_type } from "../../../utils/common";

const TripleVarientSection = ({
  product_id,
  Index,
  DIndex,
  SIndex,
  control,
  register,
  getValues,
  errors,
  setValue,
  TripleVariants,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `products.${Index}.varients.${SIndex}.double_variants.${DIndex}.triple_variants`,
  });

  const [categories, setCategories] = useState([]);

  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-vendor-p-categories");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const [days, setDays] = useState([]);
  const getAllDays = async () => {
    const response = await getData("/common/masters/all-days");
    if (response?.success) {
      setDays(await Select2Data(response?.data, "day_id"));
    }
  };
  useEffect(() => {
    getAllCategories();
    getAllDays();
  }, []);

  const [productVarient, setProductVarient] = useState([]);

  const Select2Data = async (data, name, other = false) => {
    const result = data?.map((data) => ({
      value: data?.id,
      label: data?.name,
      price: data?.price,
      name: name,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };
  const GetAllProductVarient = async (id) => {
    const response = await getData(
      `/common/masters/product-varient/${product_id?.value}`,
    );

    if (response?.success) {
      setProductVarient(await Select2Data(response?.data, "varient_id"));
    }
  };

  useEffect(() => {
    GetAllProductVarient();
  }, [product_id?.value]);

  // useEffect(() => {
  //   const fetchAndAppendVariants = async () => {
  //     const response = await getData(
  //       `/common/masters/product-varient/${product_id?.value}`
  //     );

  //     if (response?.success) {
  //       const tvariants = await Select2Data(response?.data, "varient_id");
  //       setProductVarient(tvariants);

  //       // Clear existing tvariants if any
  //       while (productVarient.length) remove(0);

  //       // Append each tvariant with full object (value + label)
  //       tvariants.forEach((tvariant) => {
  //         append({
  //           varient_id: tvariant, // { value: x, label: "name" }
  //           quantity: "",
  //         });
  //       });
  //     }
  //   };

  //   fetchAndAppendVariants();
  // }, [product_id]);

  return (
    <>
      {fields?.map((tvariant, TIndex) => (
        <div key={tvariant.value} className="border p-3 mt-3">
          <Row>
            <h5> Triple Variant {TIndex + 1}</h5>

            {/* Hidden field to store varient_id */}
            <Controller
              control={control}
              name={`products.${Index}.varients.${SIndex}.double_variants.${DIndex}.triple_variants.${TIndex}.t_variant_id`}
              defaultValue={tvariant?.id}
              render={({ field }) => <input type="hidden" {...field} />}
            />

            <Col md={4}>
              <Form.Group>
                <Form.Label>Diamond</Form.Label>

                <Form.Control
                  type="text"
                  value={tvariant.Diamond?.name}
                  readOnly
                />
              </Form.Group>
            </Col>

            {Number(product_id?.variant_type_id) === variant_type.Triple && (
              <>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Selling Price</Form.Label>
                    <Controller
                      control={control}
                      name={`products.${Index}.varients.${SIndex}.double_variants.${DIndex}.triple_variants.${TIndex}.selling_price`}
                      defaultValue={tvariant.price}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="text"
                          readOnly
                          placeholder="Selling Price"
                          isInvalid={
                            !!errors?.products?.[Index]?.varients?.[SIndex]
                              ?.double_variants?.[DIndex]?.triple_variants?.[
                              TIndex
                            ]?.selling_price
                          }
                        />
                      )}
                    />
                    <Form.Control.Feedback type="invalid">
                      {
                        errors?.products?.[Index]?.varients?.[SIndex]
                          ?.double_variants?.[DIndex]?.triple_variants?.[TIndex]
                          ?.selling_price?.message
                      }
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Stock</Form.Label>
                    <Form.Control
                      readOnly
                      type="text"
                      placeholder=" Stock"
                      {...register(
                        `products.${Index}.varients.${SIndex}.double_variants.${DIndex}.triple_variants.${TIndex}.stock`,
                        {
                          required: "Stock is required",
                        },
                      )}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];

                        // Allow only control keys and digits (0–9)
                        if (allowedKeys.includes(e.key) || /^\d$/.test(e.key)) {
                          return;
                        }

                        // Prevent decimal points or anything else
                        e.preventDefault();
                      }}
                    />
                    {/* <Form.Control.Feedback type="invalid"> */}
                    {errors?.products?.[Index]?.varients?.[SIndex]
                      ?.double_variants?.[DIndex]?.triple_variants?.[TIndex]
                      ?.stock && (
                      <span className="text-danger">
                        {
                          errors.products[Index].varients[SIndex]
                            .double_variants[DIndex].triple_variants[TIndex]
                            .stock.message
                        }
                      </span>
                    )}

                    {/* </Form.Control.Feedback> */}
                  </Form.Group>
                </Col>
              </>
            )}
          </Row>
        </div>
      ))}
    </>
  );
};

export default TripleVarientSection;
